import { createSelector } from "@reduxjs/toolkit";

import { IPointsBankProductCount } from "web/types/Banks";

import graphQLApiSlice from "web/features/api/graphQLApiSlice";

const selectBankCountsResult =
  graphQLApiSlice.endpoints.getPointsBankProductCounts.select();

const selectBankCountsForPaymentSortContext = createSelector(
  [selectBankCountsResult],
  (result) => {
    const data = result?.data ?? [];

    const productCountByBankId: Record<string, number> = {};
    const banksSub10Products = new Set<string>();

    data.forEach(
      ({ point_bank_id, product_count }: IPointsBankProductCount) => {
        productCountByBankId[point_bank_id] = product_count;

        if (product_count < 10) {
          banksSub10Products.add(point_bank_id);
        }
      }
    );

    return {
      productCountByBankId,
      banksSub10Products,
    };
  }
);

export default selectBankCountsForPaymentSortContext;
